module.exports = __webpack_public_path__ + "img/fzr.63392a83.jpg";